export const GET_MAIN_CONFIG = '@@reports/GET_MAIN_CONFIG';
export const GET_MAIN_CONFIG_SUCCESS = '@@reports/GET_MAIN_CONFIG_SUCCESS';
export const GET_MAIN_CONFIG_ERROR = '@@reports/GET_MAIN_CONFIG_ERROR';
